<section class="soluciones">
  <!-- ===== HERO + selector ===== -->
  <div class="soluciones__hero ts-mosaic-band">
    <div class="soluciones__wrap soluciones__hero-inner">
      <p class="soluciones__eyebrow">Soluciones</p>
      <h1 class="soluciones__title">Dinos a qué te dedicas.</h1>
      <p class="soluciones__lead">
        Te enseñamos la solución ya montada para tu sector: los módulos
        preseleccionados, el precio desglosado y cómo queda tu día a día.
      </p>
      <div class="soluciones__chips">
        @for (s of solutions; track s.slug) {
          <a class="sol-chip" [routerLink]="['/soluciones', s.slug]">
            <app-ts-piece piece="full" color="var(--ts-primary)" [size]="16" />
            {{ s.sector }}
          </a>
        }
        <a class="sol-chip sol-chip--dark" routerLink="/a-medida">A tu medida</a>
      </div>
    </div>
  </div>

  <!-- ===== Zona reordenable (sector primero / a-medida primero) ===== -->
  <div class="soluciones__zone">
    <div class="soluciones__sectors" [style.order]="aMedidaPrimero ? 2 : 1">
      <div class="soluciones__wrap soluciones__rows">
        <!-- Filas destacadas -->
        @for (s of featured; track s.slug) {
          <article class="sol-row">
            <div class="sol-row__body">
              <div class="sol-row__icons">
                <app-ts-piece piece="full" color="var(--ts-primary)" [size]="34" />
                @for (p of pieces(s); track $index) {
                  <app-ts-piece
                    piece="tr"
                    [color]="p.color"
                    [variant]="p.outline ? 'outline' : 'solid'"
                    [size]="29" />
                }
              </div>
              <h2 class="sol-row__name">{{ s.sector }}</h2>
              <p class="sol-row__tagline">{{ s.listingTagline }}</p>
              <div class="sol-row__pills">
                <span class="sol-pill sol-pill--base"
                  >{{ base.label }} · {{ base.price }} €</span
                >
                @for (m of s.modules; track m.label) {
                  <span class="sol-pill">+ {{ m.label }} · {{ m.price }} €</span>
                  @if (m.complement) {
                    <span class="sol-pill"
                      >+ {{ m.complement.label }} · {{ m.complement.price }} €</span
                    >
                  }
                }
              </div>
              <div class="sol-row__cta">
                <a class="ts-btn ts-btn--primary" [routerLink]="['/soluciones', s.slug]"
                  >Ver esta solución</a
                >
                @if (mostrarTotales) {
                  <span class="sol-row__total"
                    >{{ total(s) }} €/mes en total, desglosado</span
                  >
                }
              </div>
            </div>
            <app-image-slot
              class="sol-row__img"
              [src]="img(s, 'listado')"
              [hint]="s.listingImageHint"
              [minHeight]="250" />
          </article>
        }

        <!-- Cards compactas -->
        <div class="soluciones__compact">
          @for (s of compact; track s.slug) {
            <a class="sol-card" [routerLink]="['/soluciones', s.slug]">
              <div class="sol-card__icons">
                <app-ts-piece piece="full" color="var(--ts-primary)" [size]="29" />
                @for (p of pieces(s); track $index) {
                  <app-ts-piece
                    piece="tr"
                    [color]="p.color"
                    [variant]="p.outline ? 'outline' : 'solid'"
                    [size]="26" />
                }
              </div>
              <h3 class="sol-card__name">{{ s.sector }}</h3>
              <p class="sol-card__desc">{{ s.listingTagline }}</p>
              <p class="sol-card__price">{{ breakdown(s) }}</p>
              <span class="sol-card__link">Ver esta solución →</span>
            </a>
          }
        </div>
      </div>
    </div>

    <!-- Banda "A tu medida" -->
    <div class="soluciones__medida" [style.order]="aMedidaPrimero ? 1 : 2">
      <div class="soluciones__wrap">
        <div class="medida">
          <div class="medida__text">
            <span class="medida__eyebrow">A tu medida</span>
            <span class="medida__title"
              >¿Tu sector no está aquí?, ¿necesitas algo que no existe?</span
            >
            <span class="medida__desc">
              Lo desarrollamos sobre la misma plataforma, sin migrar tus datos.
              Así hemos montado gestores de obra, portales de expedientes o
              plataformas enteras de seguros.
              <a routerLink="/a-medida">Ver desarrollos a medida →</a>
            </span>
          </div>
          <a class="ts-btn ts-btn--dark" routerLink="/contacto">Cuéntanos tu caso</a>
        </div>
      </div>
    </div>
  </div>
</section>
